import { useCallback, useState } from 'react';

import { fillTranslationTextWithVariables } from 'hooks';
import { getDeviceInfo } from 'utils';
import { GameId } from 'types/enums';
import { QuizzResults } from 'types';
import { useAppStateActions, useTranslation } from 'appState';
import {
  GameFlow,
  Instructions,
  Intro,
  Quizz,
} from 'components/game';

import { GMResults } from './types';
import Feedback from '../../components/game/Feedback';
import { calcGrowthMindsetScore } from '../../utils/scoresCalc';

const GMGameFlow: React.FC = () => {
  const { gameFlowForward, submitGameResults } = useAppStateActions();
  const lang = useTranslation('GM');
  const [gameScore, setGameScore] = useState<number>(0);

  const onComplete = useCallback((scores: QuizzResults) => {
    const results: GMResults = {
      growthMindsetTestScores: scores,
      growthMindsetTestMetadata: {
        device: getDeviceInfo(),
      },
    };
    submitGameResults(GameId.GM, results);
    setGameScore(Math.round(calcGrowthMindsetScore(results.growthMindsetTestScores) * 10000)/100);
    gameFlowForward();
  }, [submitGameResults, gameFlowForward]);

  return (
    <GameFlow>
      {[
        () => (
          <Intro
            gameTitle={lang.title}
            description={lang.description}
            buttonLabel={lang.buttonLabels.intro}
            superPowerName={lang.superPowerName}
            superPower={lang.superPower}
          />
        ),
        () => (
          <Instructions
            name={lang.title}
            instructions={lang.instructions}
            nextButtonLabel={lang.buttonLabels.instructions}
          />
        ),
        () => (
          <Quizz
            questions={lang.questions}
            setSize={2}
            scoreLabels={lang.scoreLabels}
            onComplete={onComplete}
          />
        ),
        () => (
          <Feedback
            title={lang.feedback.title}
            isSliderVersion
            sliderOffset={gameScore}
            sliderLabels={lang.feedback.labels}
            skillDescription={
              gameScore > 50
                ? lang.feedback.highScoreDescription
                : lang.feedback.lowScoreDescription
            }
            subTitle={
              fillTranslationTextWithVariables(
                lang.feedback.subTitle,
                { score: gameScore || '' },
              )
            }
            description={lang.feedback.description}
          />
        ),
      ]}
    </GameFlow>
  );
};

export default GMGameFlow;
export type Results = GMResults;
